import { MY_PROGRESS } from "../types/actions";

const initialState = {
	myHistoryGraphResult: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case MY_PROGRESS.GET_MY_PROGRESS_LIST:
			return {
				...state,
				myProgressResult: action.payload
			};
		case MY_PROGRESS.GET_MY_HISTORY_GRAPH:
			return {
				...state,
				myHistoryGraphResult: action.payload
			};
		default:
			return state;
	}
};
